import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Alert, Form, InputGroup } from "react-bootstrap";
import { DeleteForever } from "@mui/icons-material";

export const ModalReprocessoDireto = ({ show, onHide, selectedWagon, onAdd, onRemove }) => {
  const [ordem, setOrdem] = useState("");
  const [verificando, setVerificando] = useState(false);

  const wagonPieces = Array.isArray(selectedWagon?.wagon) ? selectedWagon.wagon : [];
  const pecasReprocesso = wagonPieces.filter((p) => p.isReprocesso);

  const handleAdd = async () => {
    if (verificando) return;
    setVerificando(true);
    try {
      if (await onAdd(ordem)) {
        setOrdem("");
      }
    } finally {
      setVerificando(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Adicionar reprocesso direto ao vagão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Alert variant="warning" className="mb-3">
          <strong>É necessário garantir que o molde esteja livre.</strong>
          <div className="mt-1">
            Ao incluir a peça manualmente, a responsabilidade passa a ser de quem
            está fazendo a inclusão.
          </div>
        </Alert>

        <InputGroup>
          <Form.Control
            autoFocus
            placeholder="Bipe/digite a ordem de reprocesso"
            value={ordem}
            onChange={({ target }) => setOrdem(target.value)}
            onKeyDown={handleKeyDown}
            disabled={verificando}
          />
          <Button variant="warning" onClick={handleAdd} disabled={verificando}>
            {verificando ? "Verificando..." : "+ Reprocesso"}
          </Button>
        </InputGroup>

        <div className="mt-3">
          <strong>Reprocessos neste vagão ({pecasReprocesso.length}/6)</strong>
          {pecasReprocesso.length === 0 ? (
            <p className="text-muted mb-0 mt-1">Nenhuma peça de reprocesso adicionada.</p>
          ) : (
            <ul className="list-group mt-1">
              {pecasReprocesso.map((peca) => (
                <li
                  key={peca.ordem_Serial}
                  className="list-group-item d-flex justify-content-between align-items-center p-2"
                >
                  <span>{peca.ordem_Serial}</span>
                  <Button
                    variant="danger"
                    size="sm"
                    className="p-1"
                    onClick={() => onRemove(peca)}
                  >
                    <DeleteForever fontSize="small" />
                  </Button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
